import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountService {
  //  isEskyAdmin:boolean;
  //

  // options = new RequestOptions({headers: new HttpHeaders({ 'Content-Type': 'application/json' })});

  headerOption = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient) { }

  get(): Observable<any> {
    return this.http.get('api/me');
  }
  findAllcostomerbycompany(idCompany) {
    return this.http.get('/api/supervisors?idCompany=' + idCompany).pipe(map((res: Response) => res));
  }
  activateInsurrance(login, active) {
    return this.http.post('/api/activateInsurrance?login=' + login + '&active=' + active, this.headerOption);
  }
  activateInsurancePerOrder(login, active) {
    return this.http.post('/api/activateInsurrancePerOrder?login=' + login + '&active=' + active, this.headerOption);
  }
  InsuredProductValue(login, value) {
    return this.http.post('/api/InsuredProductValue?login=' + login + '&value=' + value, this.headerOption);
  }
  isAdmin() {

    return this.http.get('api/adminrole').pipe(map((res: Response) => res));
  }
  isSuperAdmin() {

    return this.http.get('api/superadminrole').pipe(map((res: Response) => res));
  }
  isCustomerAdmin() {

    return this.http.get('api/customeradminrole').pipe(map((res: Response) => res));
  }
  isCustomer() {
    // return this.http.get('api/customerrole').pipe(map((res: Response) => res));

    return this.http.get('api/customerrole');
  }
  isDropShippingAdmin() {

    return this.http.get('api/dropshippingadminrole').pipe(map((res: Response) => res));
  }
  isSales() {

    return this.http.get('api/salesrole').pipe(map((res: Response) => res));
  }


  finduserBylogin(login) {
    return this.http.get('api/finduser?login=', login);
  }

  addNewEskyAdmin(data) {
    return this.http.post(
      'api/addeskyadmin',
      JSON.stringify(data),
      this.headerOption
    )
  }
  listeskyadmins() {
    return this.http.get('api/eskyadmins').pipe(map((res: Response) => res));
  }
  deleteeskyadmin(login: string) {

    return this.http.post(
      'api/deleteaccount?login=' + login,
      this.headerOption
    )
  }
  deletecostumer(id) {

    return this.http.post(
      'api/deletecostumer?id=' + id,
      this.headerOption
    )
  }

  updatePwd(login, pwd) {
    return this.http.post('/api/updatePwd?login=' + login + '&pwd=' + pwd, this.headerOption).pipe(map((res: Response) => res));
  }

}
